import { render, staticRenderFns } from "./formula-rich-editor.vue?vue&type=template&id=4a7f5d2c&scoped=true"
import script from "./formula-rich-editor.vue?vue&type=script&lang=js"
export * from "./formula-rich-editor.vue?vue&type=script&lang=js"
import style0 from "./formula-rich-editor.vue?vue&type=style&index=0&id=4a7f5d2c&prod&lang=css"
import style1 from "./formula-rich-editor.vue?vue&type=style&index=1&id=4a7f5d2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7f5d2c",
  null
  
)

export default component.exports